module.exports = __webpack_public_path__ + "img/Minstrel show 1964 bugle 2.fb361b76.png";